<template>
  <svg class="SVG-Arrow-Tiny" xmlns="http://www.w3.org/2000/svg" width="5" height="9" viewBox="0 0 5 9" fill="none">
    <path class="SVG-Arrow-Tiny__stroke" d="M1 1.5L3.85858 4.35858C3.93668 4.43668 3.93668 4.56332 3.85858 4.64142L1 7.5" stroke="var(--gray-500)" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
</template>
